import { dia } from "@clientio/rappid";
import { Statechart } from "../mvc/statechart";

export function getModelAsJson(model: dia.Graph): string {
  return JSON.stringify(model.toJSON(), null, 2);
}

export function getStatechart(model: dia.Graph): Statechart {
  return model.getCells().find((c) => c instanceof Statechart) as Statechart;
}
